import actions from "./actions";
import mutations from "./mutations";

const state = {
  res_news: [],
  page: 1,
  page_size: 6,
  search: null,
  res_newsDetail: [],
  nameSlug: null,
  dataNews: [],
  slug: null,
  resGenerator: null,
  idNews: null,
  res_master_news: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
